import "core-js/modules/es.array.push.js";
import "core-js/modules/es.json.stringify.js";
import "core-js/modules/esnext.json.parse.js";
import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
import _imports_0 from '../assets/page-image/zccx/search.png';
const _hoisted_1 = {
  class: "zccx-wrapper"
};
const _hoisted_2 = {
  class: "header-section"
};
const _hoisted_3 = {
  class: "search-container"
};
const _hoisted_4 = {
  class: "search-box"
};
const _hoisted_5 = {
  class: "zccx-page"
};
const _hoisted_6 = {
  key: 0,
  class: "search-tag"
};
const _hoisted_7 = {
  class: "tag-value"
};
const _hoisted_8 = {
  key: 1,
  class: "result-list"
};
const _hoisted_9 = ["onClick"];
const _hoisted_10 = {
  class: "result-content"
};
const _hoisted_11 = {
  class: "result-text"
};
const _hoisted_12 = ["innerHTML"];
const _hoisted_13 = {
  class: "result-date"
};
const _hoisted_14 = {
  key: 2,
  class: "empty-state"
};
const _hoisted_15 = {
  key: 3,
  class: "empty-state"
};
const _hoisted_16 = {
  key: 4,
  class: "loading-state"
};
const _hoisted_17 = {
  key: 5,
  class: "pagination"
};
import { ref, onMounted } from 'vue';
import { useRouter, useRoute, onBeforeRouteLeave } from 'vue-router';
import Footer from '@/components/Footer.vue';
import { getPolicyList } from '@/api/news';
const CACHE_KEY = 'zccx_search_state';
const FROM_DETAIL_KEY = 'zccx_from_detail';
// 保存状态到 sessionStorage
export default /*@__PURE__*/_defineComponent({
  __name: 'Zccx',
  setup(__props) {
    const router = useRouter();
    const route = useRoute();
    const searchKeyword = ref('');
    const currentPage = ref(1);
    const pageSize = ref(10);
    const total = ref(0);
    const articleList = ref([]);
    const loading = ref(false);
    const hasSearched = ref(false);
    // 缓存键名
    const saveState = () => {
      const state = {
        searchKeyword: searchKeyword.value,
        currentPage: currentPage.value,
        total: total.value,
        articleList: articleList.value,
        hasSearched: hasSearched.value
      };
      sessionStorage.setItem(CACHE_KEY, JSON.stringify(state));
    };
    // 从 sessionStorage 恢复状态
    const restoreState = () => {
      const cached = sessionStorage.getItem(CACHE_KEY);
      if (cached) {
        try {
          const state = JSON.parse(cached);
          searchKeyword.value = state.searchKeyword || '';
          currentPage.value = state.currentPage || 1;
          total.value = state.total || 0;
          articleList.value = state.articleList || [];
          hasSearched.value = state.hasSearched || false;
          return true;
        } catch (e) {
          console.error('恢复状态失败:', e);
          return false;
        }
      }
      return false;
    };
    // 清空状态
    const clearState = () => {
      searchKeyword.value = '';
      currentPage.value = 1;
      total.value = 0;
      articleList.value = [];
      hasSearched.value = false;
      sessionStorage.removeItem(CACHE_KEY);
      sessionStorage.removeItem(FROM_DETAIL_KEY);
    };
    // 获取政策列表
    const fetchPolicyList = async () => {
      try {
        loading.value = true;
        const res = await getPolicyList({
          pageNum: currentPage.value,
          pageSize: pageSize.value,
          searchKey: searchKeyword.value
        });
        if (res.code === 200 || res.code === 0) {
          articleList.value = res.data?.list || [];
          total.value = res.data?.total || 0;
          // 保存状态
          saveState();
        }
      } catch (error) {
        console.error('获取政策列表失败:', error);
        articleList.value = [];
        total.value = 0;
      } finally {
        loading.value = false;
      }
    };
    // 搜索按钮点击
    const handleSearch = () => {
      if (!searchKeyword.value.trim()) {
        return;
      }
      currentPage.value = 1;
      hasSearched.value = true;
      fetchPolicyList();
    };
    // 分页改变
    const handlePageChange = page => {
      currentPage.value = page;
      fetchPolicyList();
      // 滚动到顶部
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    };
    // 跳转到详情页
    const goToDetail = id => {
      // 跳转前保存状态，并标记是去详情页
      saveState();
      sessionStorage.setItem(FROM_DETAIL_KEY, 'true');
      router.push(`/xwxq/${id}`);
    };
    // 格式化日期
    const formatDate = dateStr => {
      if (!dateStr) return '';
      return dateStr.substring(0, 10);
    };
    // 高亮关键词
    const highlightKeyword = text => {
      if (!searchKeyword.value || !text) return text;
      const keyword = searchKeyword.value.trim();
      if (!keyword) return text;
      const reg = new RegExp(keyword, 'gi');
      return text.replace(reg, match => `<span class="highlight">${match}</span>`);
    };
    // 页面加载时的逻辑
    onMounted(() => {
      // 检查是否从详情页返回
      const fromDetail = sessionStorage.getItem(FROM_DETAIL_KEY);
      if (fromDetail === 'true') {
        // 从详情页返回，恢复状态
        // console.log('从详情页返回，恢复状态');
        restoreState();
        // 清除标记，但保留缓存数据
        sessionStorage.removeItem(FROM_DETAIL_KEY);
      } else {
        // 从其他页面进入或首次进入，清空状态
        // console.log('从其他页面进入，清空状态');
        clearState();
      }
    });
    // 路由离开时的处理
    onBeforeRouteLeave((to, from) => {
      // 如果不是去详情页，清除标记
      if (!to.path.includes('/xwxq/')) {
        sessionStorage.removeItem(FROM_DETAIL_KEY);
      }
    });
    return (_ctx, _cache) => {
      const _component_el_pagination = _resolveComponent("el-pagination");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createElementVNode("div", {
        class: "header-title"
      }, "政策查询-快速获取政策信息", -1)), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_cache[2] || (_cache[2] = _createElementVNode("img", {
        src: _imports_0,
        alt: "",
        class: "search-icon"
      }, null, -1)), _withDirectives(_createElementVNode("input", {
        id: "search-input",
        type: "text",
        class: "search-input",
        placeholder: "请输入政策关键词，如科技创新",
        "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => searchKeyword.value = $event),
        onKeyup: _withKeys(handleSearch, ["enter"]),
        "aria-label": "搜索政策关键词"
      }, null, 544), [[_vModelText, searchKeyword.value]]), _createElementVNode("button", {
        class: "search-btn",
        onClick: handleSearch,
        "aria-label": "搜索"
      }, "搜索")])])]), _createElementVNode("div", _hoisted_5, [searchKeyword.value && articleList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_6, [_cache[4] || (_cache[4] = _createElementVNode("span", {
        class: "tag-label"
      }, "检索：", -1)), _createElementVNode("span", _hoisted_7, _toDisplayString(searchKeyword.value), 1)])) : _createCommentVNode("", true), articleList.value.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_8, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(articleList.value, item => {
        return _openBlock(), _createElementBlock("div", {
          class: "result-item",
          key: item.id,
          onClick: $event => goToDetail(item.id)
        }, [_createElementVNode("div", _hoisted_10, [_cache[5] || (_cache[5] = _createElementVNode("span", {
          class: "bullet"
        }, "●", -1)), _createElementVNode("span", _hoisted_11, [_createElementVNode("span", {
          innerHTML: highlightKeyword(item.title)
        }, null, 8, _hoisted_12)])]), _createElementVNode("div", _hoisted_13, _toDisplayString(formatDate(item.publishTime)), 1)], 8, _hoisted_9);
      }), 128))])) : !loading.value && hasSearched.value ? (_openBlock(), _createElementBlock("div", _hoisted_14, [...(_cache[6] || (_cache[6] = [_createElementVNode("div", {
        class: "empty-text"
      }, "暂无搜索结果，请尝试其他关键词", -1)]))])) : !loading.value && !hasSearched.value ? (_openBlock(), _createElementBlock("div", _hoisted_15, [...(_cache[7] || (_cache[7] = [_createElementVNode("div", {
        class: "empty-text"
      }, "请输入关键词进行搜索", -1)]))])) : _createCommentVNode("", true), loading.value ? (_openBlock(), _createElementBlock("div", _hoisted_16, [...(_cache[8] || (_cache[8] = [_createElementVNode("div", {
        class: "loading-text"
      }, "加载中...", -1)]))])) : _createCommentVNode("", true), total.value > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_17, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "total, prev, pager, next",
        total: total.value,
        "page-size": pageSize.value,
        "current-page": currentPage.value,
        "onUpdate:currentPage": _cache[1] || (_cache[1] = $event => currentPage.value = $event),
        onCurrentChange: handlePageChange
      }, null, 8, ["total", "page-size", "current-page"])])) : _createCommentVNode("", true)]), _createVNode(Footer)]);
    };
  }
});